import { useRef } from 'react'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export function useSyncTotalItems() {
  const { totalItems, setTotalItems } = useIntegrationsSyncContext()
  const lastTotal = useRef<number | undefined>(totalItems)

  const trackTotal = (total: number) => {
    if (lastTotal.current !== total) {
      lastTotal.current = total
      setTotalItems(total)
    }
  }

  return { totalItems, trackTotal }
}
